import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _chargeOverride = { price: 'FLOAT' };
var _getMeteredBillingChargesRequest = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _getMeteredBillingChargesResponse = {};
var _getPurchaseHistoryRequest = {};
var _getPurchaseHistoryResponse = { purchases: '_purchasedItem' };
var _getSitePaymentMethodsStatusRequest = {};
var _getSitePaymentMethodsStatusResponse = {};
var _getUrlRequest = { chargeOverride: '_chargeOverride' };
var _getUrlResponse = {};
var _purchasedItem = { dateCreated: 'google.protobuf.Timestamp' };
function resolveComWixpressMarketAimApiCheckoutUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/app-instance-manager-webapp',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/apps',
                destPath: '',
            },
        ],
        'wixapis.com': [
            {
                srcPath: '/apps',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
            {
                srcPath: '/api/v1/instance',
                destPath: '/v1/instance',
            },
            {
                srcPath: '/api/v1/scripts',
                destPath: '/v1/scripts',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/app-instance-manager',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves the URL for a Wix checkout page for the specified paid plan of your app.
 *
 *
 * This call succeeds only in case you have previously
 * [set up an external pricing page in the Wix Developers Center](https://dev.wix.com/docs/build-apps/build-your-app/pricing-plans/set-up-an-external-pricing-page).
 *
 * The returned checkout URL is valid for 48 hours.
 *
 * This API allows your app to manage your pricing page outside of Wix while
 * still using the standard Wix checkout flow.
 */
export function getUrl(payload) {
    var _a = serializer(_getUrlRequest, {
        _chargeOverride: _chargeOverride,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getUrlResponse, {}).fromJSON;
    function __getUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.checkout.v1.purchased_item',
            method: 'POST',
            methodFqn: 'com.wixpress.market.aim.api.Checkout.GetUrl',
            url: resolveComWixpressMarketAimApiCheckoutUrl({
                protoPath: '/v1/checkout',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getUrl.fromReq = fromReq;
    __getUrl.__isAmbassador = true;
    return __getUrl;
}
/**
 * Retrieves a list of the site owner's past purchases for your app.
 *
 *
 * You don't have to explicitly pass an identifier for the Wix site as part of
 * the request, since this information is taken automatically from the context.
 *
 * The response doesn't include any details about cancellations.
 */
export function getPurchaseHistory(payload) {
    var _a = serializer(_getPurchaseHistoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPurchaseHistoryResponse, {
        _purchasedItem: _purchasedItem,
    }).fromJSON;
    function __getPurchaseHistory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.checkout.v1.purchased_item',
            method: 'GET',
            methodFqn: 'com.wixpress.market.aim.api.Checkout.GetPurchaseHistory',
            url: resolveComWixpressMarketAimApiCheckoutUrl({
                protoPath: '/v1/checkout/history',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPurchaseHistory.fromReq = fromReq;
    __getPurchaseHistory.__isAmbassador = true;
    return __getPurchaseHistory;
}
/**
 * Retrieves information about the site's enabled payment methods.
 *
 *
 * Checks whether online, offline, Wix POS, and external POS payments are
 * enabled.
 */
export function getSitePaymentMethodsStatus(payload) {
    var _a = serializer(_getSitePaymentMethodsStatusRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSitePaymentMethodsStatusResponse, {}).fromJSON;
    function __getSitePaymentMethodsStatus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.checkout.v1.purchased_item',
            method: 'GET',
            methodFqn: 'com.wixpress.market.aim.api.Checkout.GetSitePaymentMethodsStatus',
            url: resolveComWixpressMarketAimApiCheckoutUrl({
                protoPath: '/v1/payment-method-status',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSitePaymentMethodsStatus.fromReq = fromReq;
    __getSitePaymentMethodsStatus.__isAmbassador = true;
    return __getSitePaymentMethodsStatus;
}
/**
 * Triggers Wix to call the
 * [List Custom Charges SPI](https://dev.wix.com/docs/rest/internal-only/premium/custom-charges-spi/custom-charges-provider-v1/list-charges).
 *
 *
 * Wix doesn't use the response from _List Charges_ SPI to actually create an
 * invoice that's sent to the customer. Instead, calling _Get Metered Billing Charges_
 * allows you confirm that your integration with the Custom Charges SPI is
 * working as intended.
 */
export function getMeteredBillingCharges(payload) {
    var _a = serializer(_getMeteredBillingChargesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMeteredBillingChargesResponse, {}).fromJSON;
    function __getMeteredBillingCharges(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.checkout.v1.purchased_item',
            method: 'GET',
            methodFqn: 'com.wixpress.market.aim.api.Checkout.GetMeteredBillingCharges',
            url: resolveComWixpressMarketAimApiCheckoutUrl({
                protoPath: '/v1/metered-billing-charges',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMeteredBillingCharges.fromReq = fromReq;
    __getMeteredBillingCharges.__isAmbassador = true;
    return __getMeteredBillingCharges;
}
//# sourceMappingURL=http.impl.js.map